import { useTranslation } from 'react-i18next';
import ReactECharts from "echarts-for-react";

import {ALLOWED_INPUT_CATEGORICAL_VALUES} from '../../../util/keys';
import {isoTimeToLocalString} from "../trendUtil";



const TrendHeatmap = (props) => {

    const { data, timestamps, timeAggType, graphType, localTimeZone } = props;
    const { t } = useTranslation();

    const palette =  [
        "#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0", 
        "#f46a9b", "#27aeef", "#b33dc6", "#87bc45" , "#9c4a44"
    ];


    const valueMap = Object.fromEntries(Object.entries(ALLOWED_INPUT_CATEGORICAL_VALUES).map(([k, v])=>(
        [k, Object.fromEntries(v.map((item, index)=> [item, index]))]
    )))


    const series = [];

    const yaxis = data.map((curve) => `${curve.metadata.location}`);

    for (
        let seriesIndex = 0;
        seriesIndex < data.length;
        seriesIndex++
    ) {
        let currentSeries = [];

        for (let dataIndex = 0; dataIndex < timestamps.length; dataIndex++) {
            let dataPoint = data[seriesIndex]["values"][dataIndex]

            currentSeries.push([dataIndex, seriesIndex, valueMap[graphType][dataPoint]]);
        }

        series.push({
            data: currentSeries,
            name: `${data[seriesIndex].metadata.location} - ${data[seriesIndex].metadata.system} - ${data[seriesIndex].metadata.name}`,
            type: "heatmap",
            itemStyle: {
                normal: {
                    borderColor: '#DDDDDD', 
                    borderWidth: 1        
                }
            }
        });
    }

	const options = {
		tooltip: {
			position: "top",
            confine: true,
			valueFormatter: (value) => ALLOWED_INPUT_CATEGORICAL_VALUES[graphType][value],
		},
		grid: {
			top: 0,
			bottom: 50,
            left: '0%',
            right: '5%',
            containLabel: true
		},
		xAxis: {
			type: "category",
			data: timestamps.map((ts)=>isoTimeToLocalString(ts, timeAggType, localTimeZone)),
			splitArea: {
				show: true,
			},
		},
		yAxis: {
			type: "category",
			data: yaxis,
			splitArea: {
				show: true,
			}
		},
		textStyle: {
            fontFamily: "Roboto, Helvetica, Arial, sans-serif" 
        },
		series,
	};

    options.visualMap= {
        type: "piecewise",
        splitNumber: ALLOWED_INPUT_CATEGORICAL_VALUES[graphType].length,
        min: 0,
        max: ALLOWED_INPUT_CATEGORICAL_VALUES[graphType].length,
        calculable: true,
        realtime: false,
        orient: "horizontal",
        left: "center",
        bottom: "0%",
        pieces: ALLOWED_INPUT_CATEGORICAL_VALUES[graphType].map((item, index)=>({
            min: index - 0.5, max: index + 0.5, label: item, color: palette[index % palette.length]
        })),
        showLabel: true,
        textStyle: {
            color: "black",
        },
    }
    

	return (
		<ReactECharts option={options} style={{height: 100 + (data?.length * 15 ?? 0)}} notMerge={true}/>
	);
}
 
export default TrendHeatmap;